export default __webpack_public_path__ + "static/media/910.ff9089cc.png";